/*
 * File: PatientHome.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Patient home page
 */
import React, { useCallback, useEffect, useState } from "react";
import NewPatientChart from "../topofthechart/NewPatientChart";
import PatientHomeList from "./components/PatientHomeList";
import PatientHomeSpeedDial from "./components/PatientHomeSpeedDial";
import PatientStore from "services/patients/store/PatientStore";
import PropTypes from "prop-types";
import ProviderOfficeFeeModel from "services/patients/demographics/provider_office_fee/store/ProviderOfficeFeeModel";
import UIProgress from "components/ui/UIProgress";
import { useStore } from "utils/useStore";

const PatientHome = ({ history }) => {
  const patientStore = useStore(PatientStore);
  const providerOfficeModel = useStore(ProviderOfficeFeeModel);
  const [loading, setLoading] = useState(true);

  const loadProviderModel = useCallback(async () => {
    setLoading(true);
    await providerOfficeModel.getProviderOfficeFeeData();
    setLoading(false);
  }, [providerOfficeModel]);

  const navigateToNewPatient = async newPatientId => {
    patientStore.resetAfterPatientCreation();
    await providerOfficeModel.getProviderOfficeFeeData();
    history.push("/patients/" + newPatientId + "/patient_home");
  };

  useEffect(() => {
    loadProviderModel();
  }, [loadProviderModel]);

  if (loading) return <UIProgress />;
  return (
    <div className="gradient">
      <NewPatientChart
        patientStore={patientStore}
        providerOfficeModel={providerOfficeModel}
      />
      <PatientHomeList />
      <PatientHomeSpeedDial
        navigationMethod={navigateToNewPatient}
        history={history}
      />
    </div>
  );
};

PatientHome.propTypes = {
  history: PropTypes.object.isRequired
};

export default PatientHome;
